import { isNull } from 'lodash/fp';
import React, { useMemo } from 'react';

import styles from './NettingEngine.module.scss';
import { JurisdictionalAnswers, ISDAJurisdictionalNettingInformation, JurisdictionalNettingDetailsAnswer, ISDAJurisdictionalNettingDetails } from './store';
import { NettingEngineJurisdictionResultsSection } from './NettingEngineJurisdictionResultsSection';
interface ISDANettingEngineJurisdictionAnswersProps {
    jurisdictionalResults: ISDAJurisdictionalNettingInformation;
    viewCustomConclusions: boolean;
    createQuestionAnswer: (question: string, answer: JurisdictionalNettingDetailsAnswer, noPositive?: boolean, isLocalLaw?: boolean, aetApplicable?: string | undefined) => JurisdictionalAnswers;
}

export const ISDANettingEngineJurisdictionAnswers: React.FC<ISDANettingEngineJurisdictionAnswersProps> = ({ jurisdictionalResults, viewCustomConclusions, createQuestionAnswer }) => {
    const { details, clientSignOffDetails } = jurisdictionalResults;

    const customConclusionsExist = useMemo(() => !isNull(clientSignOffDetails) && viewCustomConclusions, [clientSignOffDetails, viewCustomConclusions]);

    const { agreementCovered, counterpartyCovered, governingLawRecognised, closeOutNettingEnforceable, automaticEarlyTerminationRequired, onShoreInsolvency, offShoreInsolvency, localLawIsValid, automaticEarlyTerminationApplicable } = customConclusionsExist ? (clientSignOffDetails as ISDAJurisdictionalNettingDetails)! : details as ISDAJurisdictionalNettingDetails;

    const eachAnswer: JurisdictionalAnswers[] = useMemo(() => {
        const answers: JurisdictionalAnswers[] = [
            createQuestionAnswer('Is the selected Agreement covered by the opinion?', agreementCovered),
            createQuestionAnswer('Is the selected counterparty type covered by the opinion?', counterpartyCovered),
            createQuestionAnswer('Will the governing law of the contract be recognised?', governingLawRecognised),
            createQuestionAnswer('Is close out netting enforceable?', closeOutNettingEnforceable),
            createQuestionAnswer('Is automatic early termination required?', automaticEarlyTerminationRequired, true, false, automaticEarlyTerminationApplicable?.value),
            createQuestionAnswer('Could separate insolvency proceedings be instituted against a local branch?', onShoreInsolvency, true),
            createQuestionAnswer('Would multi-branch close-out netting be respected in a separate local branch insolvency?', offShoreInsolvency)
        ];
        if (!isNull(localLawIsValid)) {
            answers.push(createQuestionAnswer('Is the ISDA Master Agreement (when governed by the laws of your jurisdiction) enforceable?', localLawIsValid, false, true));
        }
        return answers;
    }, [agreementCovered, counterpartyCovered, governingLawRecognised, createQuestionAnswer, automaticEarlyTerminationRequired, closeOutNettingEnforceable, offShoreInsolvency, onShoreInsolvency, automaticEarlyTerminationApplicable, localLawIsValid]);

    const closeOutNettingDetails = useMemo(() => (
        <div className={styles.questionAndAnswerWrapper}>
            {eachAnswer.map(({ question, answer }, index) => (
                <div className={styles.questionAndAnswer} key={index}>
                    <div className={styles.question}>{question}</div>
                    <div className={styles.answer}>{answer}</div>
                </div>
            ))}
        </div>
    ), [eachAnswer]);

    return <NettingEngineJurisdictionResultsSection label='Close Out Details' children={closeOutNettingDetails} />;
};
